import './bootstrap';
import './website/global-scripts';
import './side-ad-banners';
import { initArmeniansLoaders } from '../core/armeniansLoader';

document.addEventListener('DOMContentLoaded', () => initArmeniansLoaders());
